/* app/js/src/components/channel/platforms/facebook/facebook-platform.component.scss */
.cursor-pointer {
  cursor: pointer;
}
input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input.ng-invalid.ng-dirty,
input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
.label {
  color: #879baf;
  display: inline-block;
  margin-right: 15px;
}
.label.note {
  font-style: italic;
  margin-top: 12px;
}
section {
  margin-bottom: 25px;
}
section div {
  font-size: 12px;
}
/*# sourceMappingURL=facebook-platform.component.css.map */
